import React from 'react';
import { ProductPriceCategory, ProductPriceType } from 'common/components/product-card/types';
import { pricesWrapper } from './styles';
import { useProductPrice } from 'common/components/product-card/use-product-price';
import { PriceBlock } from 'fronton-react';
import { usePricePrioritization } from './use-price-prioretization';

interface SimpleProductPriceToDisplayProps {
  price: ProductPriceType;
  productPriceCategory: ProductPriceCategory;
}

export const SimpleProductPriceToDisplay: React.FC<SimpleProductPriceToDisplayProps> = ({
  price,
  productPriceCategory,
}) => {
  const { mainPrice, units } = useProductPrice({
    hasOldPrice: false,
    price,
    productPriceCategory,
  });

  const priceType = usePricePrioritization(price, productPriceCategory);

  return (
    <div className={pricesWrapper}>
      <PriceBlock price={mainPrice} units={units} type={priceType} size="s" direction="horizontal" />
    </div>
  );
};
